import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import UsuariosAdminAll from './components/UsuariosAdminAll';

export default function UsuariosAdmin() {
  return (
    <>
      <MainContent
        titulo='Administración de Usuarios'
        component={<UsuariosAdminAll />}
        tableMaxWidth
      />
      
      <Outlet />
    </>
  );
}